import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import Send from '../../core/communication';
import EmbrapaSuinosDetailsScreen from '../../screen/EmbrapaSuinosDetailsScreen';
import { getIds } from '../../core/utils/getIds';
import { useProjects } from "../SelectProjectCompanyContainer"
import { sort } from 'fast-sort';
import { formatNumber, getAnnualVolume, getAreasDetails, getFertilizerByApplications, getOffer, getVolumeAreas, getWaterConsumptionLevel } from '../../core/embrapa/calculations';
import { TABLE_MODEL_OFFER, getApplicationTable, getOfferTable } from '../../core/embrapa/calculations/nutrientTables';

const formattingData = async (farms = [], allData = []) => {
  let newFormattedData = [];
  for await (const farm of farms) {
    let years = [moment().year()];
    const allFarmData = allData.filter(item => item['Envio_Formulario'] === farm['Envio_Formulario']);
    const farmCulturesReference = allData
    .filter(item => item && item.Etapa_Pergunta === 'f335c141-3a9a-11ed-89ea-42010a800077:fa463a8c-3a9a-11ed-89ea-42010a800077');

    const farmApplicationsReference = allData
    .filter(item => item && item.Etapa_Pergunta === '17b30fcf-3a9b-11ed-89ea-42010a800077:1cd3047e-3a9b-11ed-89ea-42010a800077');

    const farmAreaReference = allData
      .filter(item => item && item.Etapa_Pergunta === 'e5c9db7f-3a9a-11ed-89ea-42010a800077:a0fde54e-44d6-11ed-89ea-42010a800077')
      .filter(item => item && item.Resposta === farm.Atendimento)
      .map(area => {
        const allAreaData = allData.filter(item => item['Envio_Formulario'] === area['Envio_Formulario']);
        const applications = farmApplicationsReference.filter(item => item && item.Resposta === area.Atendimento)
        .map(application => {
          const allApplicationData = allData.filter(item => item['Envio_Formulario'] === application['Envio_Formulario']);

          return {
            areaId: application.Resposta,
            wasteApplicationDate: allApplicationData.find(item => item.Etapa_Pergunta === '17b30fcf-3a9b-11ed-89ea-42010a800077:2bb4e55e-0fec-45c2-91b0-99143803177d')?.Resposta ?? 0,
            applicationYear: allApplicationData.find(item => item.Etapa_Pergunta === '17b30fcf-3a9b-11ed-89ea-42010a800077:cb26bc61-1da9-4eb4-8ca0-67d390c2d2f3')?.Resposta ?? 2023,
            farmId: allApplicationData.find(item => item.Etapa_Pergunta === '17b30fcf-3a9b-11ed-89ea-42010a800077:24bb53a6-fda3-43c7-93b7-0a1ce32d5b33')?.Resposta ?? '',
            volumeApplied: allApplicationData.find(item => item.Etapa_Pergunta === '17b30fcf-3a9b-11ed-89ea-42010a800077:1cd39933-3a9b-11ed-89ea-42010a800077')?.Resposta ?? 0,
            applicationTime: allApplicationData.find(item => item.Etapa_Pergunta === '17b30fcf-3a9b-11ed-89ea-42010a800077:1cd398de-3a9b-11ed-89ea-42010a800077')?.Resposta ?? 0,
            equipmentType: allApplicationData.find(item => item.Etapa_Pergunta === '17b30fcf-3a9b-11ed-89ea-42010a800077:1cd3971c-3a9b-11ed-89ea-42010a800077')?.Resposta ?? 0,
          }
        })
        
        const cultures = farmCulturesReference.filter(item => item && item.Resposta === area.Atendimento)
          .map(culture => {
            const allCultureData = allData.filter(item => item['Envio_Formulario'] === culture['Envio_Formulario']);
            const plantingYear = allCultureData.find(item => item.Etapa_Pergunta === 'f335c141-3a9a-11ed-89ea-42010a800077:fa464003-3a9a-11ed-89ea-42010a800077')?.Resposta ?? '2023';

            years = sort([...new Set([...years, Number(plantingYear)])]).asc();

            return {
              areaId: culture?.Resposta,
              cultureType: allCultureData.find(item => item.Etapa_Pergunta === 'f335c141-3a9a-11ed-89ea-42010a800077:fa463e6b-3a9a-11ed-89ea-42010a800077')?.Resposta ?? '',
              culture: allCultureData.find(item => item.Etapa_Pergunta === 'f335c141-3a9a-11ed-89ea-42010a800077:fa463eff-3a9a-11ed-89ea-42010a800077')?.Resposta ?? '',
              productionExpectation: allCultureData.find(item => item.Etapa_Pergunta === 'f335c141-3a9a-11ed-89ea-42010a800077:fa463f54-3a9a-11ed-89ea-42010a800077')?.Resposta ?? '',
              plantingMonth: allCultureData.find(item => item.Etapa_Pergunta === 'f335c141-3a9a-11ed-89ea-42010a800077:fa463fb7-3a9a-11ed-89ea-42010a800077')?.Resposta ?? 1,
              plantingYear,
              harvestMonth: allCultureData.find(item => item.Etapa_Pergunta === 'f335c141-3a9a-11ed-89ea-42010a800077:fa46404b-3a9a-11ed-89ea-42010a800077')?.Resposta ?? 1,
              harvestYear: allCultureData.find(item => item.Etapa_Pergunta === 'f335c141-3a9a-11ed-89ea-42010a800077:fa46408e-3a9a-11ed-89ea-42010a800077')?.Resposta ?? 2023,
            }
          })

        return {
          farmId: area.Resposta,
          areaThirdParty: allAreaData.find(item => item.Etapa_Pergunta === 'e5c9db7f-3a9a-11ed-89ea-42010a800077:4ed408a0-b52e-4467-b2ca-982a90a6d31c')?.Resposta ?? false,
          ha: allAreaData.find(item => item.Etapa_Pergunta === 'e5c9db7f-3a9a-11ed-89ea-42010a800077:ec245235-3a9a-11ed-89ea-42010a800077')?.Resposta ?? 0,
          clay: allAreaData.find(item => item.Etapa_Pergunta === 'e5c9db7f-3a9a-11ed-89ea-42010a800077:ec24565c-3a9a-11ed-89ea-42010a800077')?.Resposta ?? 0,
          p: allAreaData.find(item => item.Etapa_Pergunta === 'e5c9db7f-3a9a-11ed-89ea-42010a800077:ec2456d8-3a9a-11ed-89ea-42010a800077')?.Resposta ?? 0,
          cultures,
          applications
        }
      })

    if(allFarmData && allFarmData.length) {
      newFormattedData.push({
        id: farm?.Atendimento,
        formSubmissionId: farm?.Envio_Formulario,
        userId: farm?.Tecnico,
        date: farm?.Data?.value,
        title: allFarmData.find(item => item.Etapa_Pergunta === '28ac15c9-e110-11ec-be1e-0242ac110002:d6bb8927-3a9a-11ed-89ea-42010a800077')?.Resposta,
        description: allFarmData.find(item => item.Etapa_Pergunta === '28ac15c9-e110-11ec-be1e-0242ac110002:d6bc68c3-3a9a-11ed-89ea-42010a800077')?.Resposta,
        accommodationCapacity: allFarmData.find(item => item.Etapa_Pergunta === '28ac15c9-e110-11ec-be1e-0242ac110002:d6bc6902-3a9a-11ed-89ea-42010a800077')?.Resposta,
        waterConsumption: allFarmData.find(item => item.Etapa_Pergunta === '28ac15c9-e110-11ec-be1e-0242ac110002:d6bc6987-3a9a-11ed-89ea-42010a800077')?.Resposta,
        totalVolume: allFarmData.find(item => item.Etapa_Pergunta === '28ac15c9-e110-11ec-be1e-0242ac110002:d6bc693b-3a9a-11ed-89ea-42010a800077')?.Resposta,
        areas: farmAreaReference,
        years
      })
    }
  }

  return newFormattedData || [];
}

const EmbrapaDetailsSuinosContainer = () => {
  const { projects } = useProjects()
  const { id_user } = useParams()
  const [year, setYear] = useState(moment().year())
  const [tab, setTab] = useState(0)
  const [totalAnnualVolume, setTotalAnnualVolume] = useState(0);
  const [totalDemandVolume, seTotalDemandVolume] = useState(0);
  const [volumeApplied, setVolumeApplied] = useState(0);
  const [allApplications, setAllAplications] = useState([]);
  const [totalNetBenefit, setTotalNetBenefit] = useState('00,00');
  const [nutrientOfferTable, setOfferTable] = useState(TABLE_MODEL_OFFER);
  const [unformattedData, setUnformattedData] = useState([]);
  const [selectedFarm, setSelectedFarm] = useState();
  const [haveExcessNutrients, setHaveExcessNutrients] = useState(false);
  const [waterMetric, setWaterMetric] = useState([
    { id: 0, color: '#edb5a5', text: '5 L/cab./dia', },
    { id: 1, color: '#D3461E', text: '7 L/cab./dia', },
    { id: 2, color: '#FFFFFF', text: '9 L/cab./dia', },
])

  const [newValues, setNewValues] = useState([]);

  const loadData = async () => {
    if (id_user && projects.length > 0) {
      let extraProps = ""

      if (id_user) {
        extraProps += `&farmers=${getIds([{ value: id_user }])}`
      }

      const dw = await Send.get("/dw/suinos", `projects=${getIds(projects.map(item => ({ value: item.id })))}${extraProps}`)
      
      const farms = dw.filter(item => item.Etapa_Pergunta === '28ac15c9-e110-11ec-be1e-0242ac110002:d6bb8927-3a9a-11ed-89ea-42010a800077'); // nome da granja
      const formattedData = await formattingData(farms, dw);

      setNewValues(formattedData);
      setUnformattedData(dw);
    }
  }

  const calculationLoading = () => {
    const waterLevel = getWaterConsumptionLevel(selectedFarm?.description.split(" - ")[0])
    const totalAnnualVolumeResult = getAnnualVolume(
      selectedFarm?.accommodationCapacity || 0,
      selectedFarm?.description?.split(' ')[0] || "",
      selectedFarm?.waterConsumption === 'Baixo' ? 'low' : selectedFarm?.waterConsumption === 'Médio' ? 'average' : 'height'
    );

    const systemType = selectedFarm?.description.split('-')[0];
    const accommodation = Number(selectedFarm?.accommodationCapacity || 1);

    const filteredAreas = getAreasDetails(
      selectedFarm?.areas,
      parseInt(selectedFarm?.accommodationCapacity, 10),
      selectedFarm?.description.split(" ")[0],
      selectedFarm?.waterConsumption === 'Baixo' ? 'low' : selectedFarm?.waterConsumption === 'Médio' ? 'average' : 'height',
      year
    );

    let newApplications = [];
    let netBenefit = 0;

    filteredAreas?.map(area => {
      const yearApplications = area?.applications ? area?.applications.filter(application => application?.applicationYear == year) : [];
      if (yearApplications && yearApplications.length) {
        newApplications = [
          ...newApplications,
          ...yearApplications
        ]
      }
    });

    const newVolumeApplied = getVolumeAreas(newApplications) || 0

    const fertilizerPrice = getFertilizerByApplications(
      filteredAreas,
      parseInt(selectedFarm?.accommodationCapacity, 10),
      selectedFarm?.description.split(" ")[0],
      totalAnnualVolumeResult,
      year
    );

    netBenefit = fertilizerPrice[filteredAreas?.length - 1]?.totalNetBenefit || 0;

    if (netBenefit) {
      netBenefit = formatNumber(netBenefit || 0)
    }
    
    const newTable = getOfferTable(filteredAreas || [], `${systemType}`.trim(), accommodation);

    const N_demand = getApplicationTable(filteredAreas, totalAnnualVolumeResult, year)?.tableData[0][0].split(" ")[0];

    let newDemandVolume = newVolumeApplied * parseInt(N_demand, 10);
    newDemandVolume /= getOffer(
      'N',
      parseInt(selectedFarm?.accommodationCapacity, 10),
      selectedFarm?.description.split(" ")[0]
    ) || 0;

    const [secondNutrientDemand, secondNutrientOffer] = [newTable.tableData[1][0].split(' ')[0] || 0, newTable.tableData[1][1].split(' ')[0] || 0];

    if(Number(secondNutrientDemand) >= Number(secondNutrientOffer)) {
      setHaveExcessNutrients(false)
    } else {
      setHaveExcessNutrients(true)
    }

    setWaterMetric([
      { id: 0, color: '#edb5a5', text: `${waterLevel?.low.toFixed(1) || 0} L/cab./dia` },
      { id: 1, color: '#D3461E', text: `${waterLevel?.average.toFixed(1) || 0} L/cab./dia` },
      { id: 2, color: '#FFFFFF', text: `${waterLevel?.height.toFixed(1) || 0} L/cab./dia` },
    ])
    seTotalDemandVolume(newDemandVolume || 0);
    setTotalNetBenefit(netBenefit || '00,00');
    setVolumeApplied(newVolumeApplied)
    setAllAplications(newApplications);
    setTotalAnnualVolume(totalAnnualVolumeResult);
    setOfferTable(newTable);
  }

  useEffect(() => {
    if(selectedFarm && selectedFarm.id) {
      calculationLoading();
    }

    return () => setTotalAnnualVolume(0);
  }, [selectedFarm, year]);

  useEffect(() => {
    loadData()
  }, [id_user])

  return <EmbrapaSuinosDetailsScreen
    selectedFarm={selectedFarm}
    formattedData={newValues}
    setSelectedFarm={setSelectedFarm}
    allData={unformattedData || []}
    totalAnnualVolume={totalAnnualVolume}
    year={year}
    setYear={setYear}
    tab={tab}
    setTab={setTab}
    nutrientOfferTable={nutrientOfferTable}
    volumeApplied={volumeApplied}
    netBenefit={totalNetBenefit}
    totalDemandVolume={totalDemandVolume}
    haveExcessNutrients={haveExcessNutrients}
    waterMetric={waterMetric}
  />

}

//78b52464-1665-4772-acc5-11933d879e0e

export default EmbrapaDetailsSuinosContainer;